export const MSGS = {
  EMPLOYEE_ADD_SUCCESS: "Employee added successfully",
  EMPLOYEE_UPDATE_SUCCESS: "Employee updated successfully",
  CHANGE_PASSWORD_SUCCESS: "Password updated successfully",
};

export default MSGS;
